import React, { useState, useEffect } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import Snackbar from "../snackbar";
// import UploadButton from "./UploadButton";
// import UploadStatus from "./UploadStatus";
import _ from "lodash";
import { Create, TopToolbar, ListButton,useTranslate,useGetOne,Button } from "react-admin";
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const LoyaltyRewardEdit = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location?.pathname.split("/");
  const LoyaltyId = path[2];
  const { data } = useGetOne("loyalty_rewards", { id: path[2] });

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");

  const [rewards, setRewards] = useState("");
  const [points, setPoints] = useState(null);
  // const [expiryDate, setExpiryDate] = useState(new Date());

  const [rewardsError, setRewardsError] = useState(false);
  const [pointsError, setPointsError] = useState(false);
  const [pointsErrorMsg, setPointsErrorMsg] = useState(null);


  const [balanceError, setBalanceError] = useState(false);
  const [balanceErrorMsg, setBalanceErrorMsg] = useState("");


  useEffect(() => {
    console.log('dataaaaaaaaaaaaaaaaaaaaa',data, data?.points > 0);
    setRewards(data?.rewards);
    setPoints(data?.points);
  }, [data]);



  const changeRewards = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setRewardsError(true);
    } else {
      setRewardsError(false);
    }
    setRewards(positionObject);
  };

  const changePointsNumber = (event) => {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const numberPattern = /^[0-9\b]+$/;
    const reg = new RegExp("^d+$");
    setBalanceError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      reg.test(positionObject)||
      !numberPattern.test(positionObject)
    ) {
      setPointsError(true);
      setPointsErrorMsg(translate('resources.loyalty_rewards.fields.enter_valid_points'))
    } else if(event.target.value <= 0){
      setPointsError(true);
      setPointsErrorMsg(translate('resources.loyalty_rewards.fields.enter_points_above_zero'))
    }else if(event.target.value > 100000){
      setPointsError(true);
      setPointsErrorMsg(translate('resources.user_loyalty_points.fields.enter_points_below_thousand'))
    }
    else {
      setPointsError(false);
      setPointsErrorMsg(null)
    }
    setPoints(positionObject);
  };

  const sumbitForm = () => {

    setPointsError(false);
    setPointsErrorMsg(null);
    setOnSaveDisabled(true);
    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const formData = new FormData();
    // formData.append('business', splituserId)
    formData.append("points", points);
    formData.append("rewards", rewards);
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "PATCH";


    options.body = formData;
    fetch(`${apiUrl}/loyalty_rewards/${LoyaltyId}`, {
      method: "PATCH",
      body: formData,
      headers: {
        Authorization: userData._token,
      },
    })
      .then((res) => {
        // return res.json();
        return new Promise((resolve) =>
          res.json().then((json) =>
            resolve({
              status: res.status,
              json,
            })
          )
        );
      })
      .then(({ status, json }) => {
        // console.log(".............", json , status);
        switch (status) {
          case 400:
          case 422:
            console.log("error", json);
            setBalanceError(true);
            setBalanceErrorMsg(json.error);
            break;
          case 201:
          case 200:
            setShowSnackbar(true);
            setTimeout(() => {
              navigate(-1);
            }, 1000);
            break;
          default:
            console.log("default", status);
            break;
        }
      })
      .catch((error) => {
        console.log("error==>", error);
      });

    
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', userId);

  const deleteConfirm = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(location.pathname);
      }
    });
  };

  const deleteData = (path) => {
    const splitURL = path.toString().split("/");
    const dataId = splitURL[splitURL.length - 1];

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "delete";
    fetch(`${apiUrl}/loyalty_rewards/${dataId}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setTimeout(() => {
          window.location.href = "/loyalty_rewards/";
        }, 1000);
        // console.log("obj==>", jsonD);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CreateActions = ({ basePath, data }) => (
    <TopToolbar>
      <Button
        label="Delete"
        className="delete-button-style icon-delete"
        onClick={() => deleteConfirm()}
      ></Button>
      <ListButton basePath={basePath} />
    </TopToolbar>
  );
  const translate = useTranslate();

  // {translate('resources.users.fields.updated_by_id')}
  return formSettings ? (
    <Create actions={<CreateActions />} title={translate('resources.loyalty_rewards.fields.create_reward')} {...props}>
      <div className="so-form">
        <div className="so-input">
          <label>
          {translate('resources.loyalty_rewards.fields.reward')}<sup>*</sup>
          </label>
          <textarea className="inapp-notification-description" type="text" value={rewards} onChange={changeRewards} />
          {rewardsError && <p className="so-input-error">{translate('resources.loyalty_rewards.fields.enter_reward')}</p>}
        </div>

        <div className="so-input">
          <label>
          {translate('resources.loyalty_rewards.fields.points')}<sup>*</sup>
          </label>
          <input
            type="number"
            min="0"
            maxLength="18"
            value={points}
            onChange={changePointsNumber}
          />
          {pointsError && (
            <p className="so-input-error">{pointsErrorMsg}</p>
          )}

          {balanceError && (
            <p className="so-input-error">{balanceErrorMsg}</p>
          )}
        </div>


        <div></div>
        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={
              !rewards ||
              rewardsError ||
              !points ||
              pointsError
            }
          >
            <span>{translate('resources.users.fields.save')}</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
    </Create>
  ) : (
    <div>loading</div>
  );
};

export default LoyaltyRewardEdit;
